import { MOLECULE_SECTION } from "../../constants";

export function isMoleculeslistArray(x: any): x is [] {
  return Array.isArray(x);
}

export function isMoleculeslistObject(x: any): x is TMoleculeslistObject {
  return typeof x === "object" && x !== null && MOLECULE_SECTION.CHIMIO in x && MOLECULE_SECTION.THERAPY in x;
}

export function isLang(x: any): x is Lang {
  return ['fr', 'en', 'es', 'it'].includes(x);
}

export function isBiblio(x: any): x is TBiblio {
  return Array.isArray(x);
}